import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-aror-range',
  templateUrl: './aror-range.component.html',
  styleUrls: [],
  standalone: false
})
export class ARReceiptRangeComponent {
  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
